
import { Component, Prop, Vue } from 'vue-property-decorator'
import StarRating from 'vue-star-rating/src/star-rating.vue'

@Component({
  components: {
    StarRating,
  },
})
export default class ReviewStarRating extends Vue {
  @Prop()
    rating: string

  ratingSelected(event) {
    this.$emit('input', event)
  }
}
